import { useMutation } from '@tanstack/react-query';

import { WorkingHoursFormSchemaValues } from 'src/features/workingHours/utils/formSchema';
import { WorkingHours } from 'src/features/workingHours/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/site-working-hours/`;

type MutationFnType = typeof mutationFn;

interface DTO extends WorkingHoursFormSchemaValues {
    siteId: string;
    parkingId: string;
}
const mutationFn = ({ siteId, parkingId, ...data }: DTO): Promise<WorkingHours> => {
    return axios.post(formatResourcePath(RESOURCE, { siteId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateWorkingHours };
